'use strict';
angular.module('schoolLinqApp').factory('prLeaveService', [
	'$http',
	function ($http) {
		var endpoint = '/api/prleave';

		function list() {
			return $http.get(endpoint + '/list');
		}

		function get(Id) {
			return $http.get(endpoint, { params: { Id: Id } });
		}

		function addOrUpdate(leave) {
			return $http.post(endpoint, leave);
		}

		function deleteLeaveType(prLeaveIdToDelete) {
			return $http.delete(endpoint, {
				params: { prLeaveIdToDelete: prLeaveIdToDelete },
			});
		}

		return {
			list: list,
			get: get,
			addOrUpdate: addOrUpdate,
			deleteLeaveType: deleteLeaveType,
		};
	},
]);
